// extracted by mini-css-extract-plugin
export default {"cancelTranslation_container":"CancelTranslation_cancelTranslation_container__-mJFm"};